import React from "react";
import CountUp from "./common/CountUp";
import Icon from "./common/Icon";
import { bnToNumber } from "../utils/format";

export default function PricePanel({ market, data }) {
  const price = data && data.price ? bnToNumber(data.price) : 0;
  const noLiquidity = data && data.price && data.price.isZero();

  return (
    <>
      <div className="hero hero-anim">
        <div className="hero-label">{market.label} Price</div>
        <div className="hero-value">
          {noLiquidity ? <span style={{ fontSize: 24 }}>Awaiting liquidity</span> : <>$<CountUp value={price} decimals={market.priceDecimals} /></>}
        </div>
        <div className="muted mt-2" style={{ fontSize: 13 }}>
          Live price · {market.name}
        </div>
      </div>

      <div className="card">
        <div className="row" style={{ gap: 10 }}>
          <span className="dex-note-ico"><Icon name="shield" size={18} /></span>
          <p className="muted" style={{ margin: 0, fontSize: 12.5, lineHeight: 1.55 }}>
            {market.key === "core"
              ? "Selling sends your CORE to the burn address and pays USDT from the vault. A 10% Swap fee stays as liquidity, supporting the price."
              : "Selling burns your SCN and pays USDT from the vault. A 10% Swap fee stays as liquidity, supporting the price for holders."}
          </p>
        </div>
      </div>
    </>
  );
}
